<div class="fixed left-0 right-0 top-0 z-[1000] h-full w-100vw animate-fadeIn" [class.backdrop-blur]="blur()">
    <div
        class="absolute top-0 left-0 h-full w-full bg-black-{{ blackOpacityPercentage() }}"
        [class.backdrop-blur]="blur()"
        (click)="closeDialog(); $event.stopPropagation()"
    ></div>
    <ng-content />
</div>
